module.exports = global["$"] = require("-!/Users/chris/Projects/99designs/start/assets/node_modules/jquery/dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?$!./node_modules/jquery/dist/jquery.js
// module id = 660
// module chunks = 0